module.exports = __webpack_public_path__ + "img/kid.762217b7.svg";